const typeStyles = {
  success: 'bg-[#16a34a] text-white',
  error: 'bg-[#dc2626] text-white',
  warning: 'bg-[#d97706] text-white',
  info: 'bg-[#1B1223AA] text-white',
};

const Toast = ({ message, type = 'info' }) => {
  if (!message) { return null; }
  const style = typeStyles[type] || typeStyles.info;
  return (
    <div className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 ${style} px-4 py-2 rounded-lg shadow-lg z-[999] text-sm font-medium text-center`}>
      {message}
    </div>
  );
};

export default Toast;
